import React, { useState } from 'react';

import styles from '../css/citations.module.css';

interface Props {
  header:string
  filterOptions: string[]
  sortByOccurance:boolean,
  rawValuesForCount: string[],
  selected: string[]
  nullOptionReplacement: string
  onChangeCallback: any
}

const MAX_ITEMS = 5

const FilterGroup:React.FC<Props> = ({header, filterOptions, rawValuesForCount, selected, nullOptionReplacement, sortByOccurance, onChangeCallback}) => {

  let [expanded, setExpanded] = useState(false)

  if (sortByOccurance){
    filterOptions = filterOptions.sort((a,b)=>{
      return rawValuesForCount.filter(v=>v===b).length - rawValuesForCount.filter(v=>v===a).length
    })
  }

  return <div className={`${styles.mReferencesFilterContainer}`} role="listitem">
    <div className={`${styles.mReferencesFilterTitle}`}>{(header).toString().toUpperCase()}</div>
    <div className={`${styles.mReferencesFilterChkboxes}`}>
      {
        filterOptions.slice(0, expanded?filterOptions.length:MAX_ITEMS).map((filterOption, index)=>{
          let value = filterOption || nullOptionReplacement
          let i = index
          return (<div key={`div-${i}`} className={`${styles.citationsFilterChkbox} ${value===nullOptionReplacement&&value!=='Independent'?styles.citationsFilterUnknown:""}`}>
            <input
              aria-label={value}
              type="checkbox"
              name={value}
              checked={selected?.includes(value)}
              onChange={onChangeCallback}
              value={value}
            />
            <label key={`${value}-${i}`} htmlFor={value}>
              {value} ({rawValuesForCount.filter(v=>v===filterOption).length})
            </label>
          </div>)
          // return <Checkbox label={filterOption} key={filterOption} value={filterOption} checked={selected?.includes(filterOption)} onChange={onChangeCallback}/>
        })
      }
      {filterOptions.length > MAX_ITEMS?<div onClick={()=>setExpanded(!expanded)} className={`${styles.seeMoreSeeLess}`}>
        {expanded ? 'See fewer' : 'See more'}
      </div>:<></>}
    </div>
  </div>
};

export default FilterGroup;
